import { IRate, RATE_ACTION_TYPE, IRateType, ILocation, IOfferLimits } from 'types/contractLanes'
import {
  RoutingGuideRowProps,
  LaneLocation,
  CarrierApplicationOfferLimits,
} from 'apps/marketplace/apiTypes/carrierRoutingGuides'
import {
  ASAP,
  ANY,
  CUSTOM_END_DATE,
  CUSTOM_START_DATE,
  LANE_RATE,
} from 'apps/marketplace/utils/constants/rates'

const LaneLocationToILocation = (location: LaneLocation): ILocation => {
  const { city, countryCode, stateCode } = location || {}
  return {
    city: city || 'N/A',
    state: stateCode,
    stateCode,
    countryCode,
  }
}

const EnhancedCarrierApplicationOfferLimits = (
  limit?: CarrierApplicationOfferLimits
): IOfferLimits | undefined => {
  return limit
    ? {
        ...limit,
        pickupCity: limit.pickupLocation.city,
        pickupStateCode: limit.pickupLocation.stateCode,
        pickupRadius: limit.pickupLocation.radius,
      }
    : undefined
}

const LaneSupportsBandedRates = (
  contractId?: number,
  pickupCity?: string,
  pickupStateCode?: string,
  deliveryCity?: string,
  deliveryStateCode?: string
): boolean => {
  return Boolean(contractId) && pickupCity === deliveryCity && pickupStateCode === deliveryStateCode
}

export const routingGuideRowPropsToIRate = (routingGuide: RoutingGuideRowProps): IRate => {
  const {
    approvedAt,
    approvedById,
    carrier,
    carrierApplicationOfferLimits,
    contractId,
    createdAt,
    createdBy,
    delivery,
    deliveryRadiusMiles,
    deliveryRadiusRangeMax,
    deliveryRadiusRangeMin,
    deliveryTimePreference,
    dispatcher,
    equipment,
    expirationDate,
    isDatMarketApplicable,
    isOnlyBeer,
    isOnlyDropTrailer,
    isShipperExclusive,
    loadType,
    pickup,
    pickupRadiusMiles,
    pickupTimePreferences,
    rate,
    shipper,
    startDate,
  } = routingGuide || {}
  const { id: carrierId, legalName: carrierName } = carrier || {}
  const { id: equipmentId } = equipment || {}
  const { id: shipperId, name: shipperName } = shipper || {}
  const {
    firstName: dispatcherFirstName,
    lastName: dispatcherLastName,
    parentUserId: dispatcherParentUserId,
  } = dispatcher || {}
  const { city: pickupCity, stateCode: pickupStateCode } = pickup || {}
  const { city: deliveryCity, stateCode: deliveryStateCode } = delivery || {}

  const laneSupportsBandedRates = LaneSupportsBandedRates(
    contractId,
    pickupCity,
    pickupStateCode,
    deliveryCity,
    deliveryStateCode
  )

  const convertedIRate: IRate = {
    contractId,
    carrierId,
    carrierName,
    rate,
    carrier,
    equipmentId,
    equipment,
    pickupTimePreferences,
    deliveryTimePreference,
    expirationDate,
    startDate,
    createdAt,
    createdBy,
    loadType,
    isOnlyBeer,
    isOnlyDropTrailer,
    isShipperExclusive,
    isDatMarketApplicable,
    shipper,
    shipperId,
    shipperName,
    deliveryRadiusRangeMax,
    deliveryRadiusRangeMin,
    pickupRadiusMiles,
    deliveryRadiusMiles,
    laneSupportsBandedRates,
    radiusRates: [],
    pickup: LaneLocationToILocation(pickup),
    pickupLocation: LaneLocationToILocation(pickup),
    delivery: LaneLocationToILocation(delivery),
    deliveryLocation: LaneLocationToILocation(delivery),
    dispatcher: { ...dispatcher, parentId: dispatcherParentUserId },
    dispatcherList: [{ ...dispatcher, parentId: dispatcherParentUserId }],
    dispatcherName: `${dispatcherFirstName} ${dispatcherLastName}`,
    actionType: RATE_ACTION_TYPE.reserved,
    startType: startDate ? CUSTOM_START_DATE : ASAP,
    expirationType: CUSTOM_END_DATE,
    rateType: laneSupportsBandedRates ? undefined : (LANE_RATE as IRateType),
    pickupTimeType: ANY,
    laneId: routingGuide.contractId,
    carrierApplicationOfferLimits: EnhancedCarrierApplicationOfferLimits(
      carrierApplicationOfferLimits
    ),
    ...(approvedAt && { approvedAt }),
    ...(approvedById && { approvedById }),
  }
  return convertedIRate
}
